<template>
    <div class="input">
        <div class="input__checkbox">
            <input
                :id="`${_uid}-input`"
                name="opt-in"
                class="input__checkbox-item"
                type="checkbox"
                v-model="checked">
            <label
                :for="`${_uid}-input`"
                class="input__checkbox-label input__checkbox-label--align-top">
                <slot/>
            </label>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Checkbox',
    data: () => {
        return {
            checked: false,
        };
    },
    props: {
        initialValue: {
            default: false,
            type: Boolean,
        },
        value: {
            default: false,
            type: Boolean,
        },
        option: {
            required: false,
            type: String,
        },
        shopCheckbox: {
            default: false,
            type: Boolean,
        },
    },
    computed: {
        inputClass() {
            return this.shopCheckbox ? 'shop__input' : 'input';
        },
        checkboxClass() {
            return this.shopCheckbox ? `shop__checkbox` : 'input__checkbox';
        },
        labelClass() {
            return this.shopCheckbox ? 'shop__checkbox__label' : 'input__checkbox-label input__checkbox-label--align-top';
        },
        iconClass() {
            return this.shopCheckbox ? 'shop__checkbox__item' : 'input__checkbox-item';
        },
    },
    created() {
        this.$parent.$on('clear', this.clear);
        this.checked = this.initialValue;
    },
    methods: {
        clear() {
            this.checked = false;
        },
    },
    watch: {
        checked(value) {
            this.$emit('input', value);
            if (this.option) this.$emit('optionSelect', this.option, value);
        },
        value: {
            immediate: true,
            handler(value) {
                this.checked = value;
            },
        },
    },
};
</script>
